import React, { Component } from "react";
import map from "lodash.map";
import findIndex from "lodash.findindex";

class SelectId {
  static id = 0;

  static get() {
    this.id++;

    return this.id;
  }
}

export class Select extends Component {
  constructor() {
    super();

    this.state = {
      focuse: false,
    };

    this.id = SelectId.get();
    this.over = false;

    this.handleFocus = () => {
      if (!this.state.focused) {
        this.setState({
          focused: this.props.disabled ? false : true,
        });
      }
    };

    this.handleBlur = () => {
      if (this.state.focused && !this.over) {
        this.setState({
          focused: false,
        });
      } else if (this.over) {
        this.select.focus();
      }
    };

    this.handleMouseLeave = () => {
      this.over = false;
    };

    this.handleMouseEnter = () => {
      this.over = true;
    };
  }

  handleSelect(option) {
    this.setState(
      {
        focused: false,
      },
      () => {
        this.select.blur();
      }
    );

    this.over = false;

    this.props.onSelect(option);
  }

  render() {
    const { focused } = this.state;
    const {
      options,
      value,
      required = false,
      ["aria-required"]: ariaRequired,
      isObjectValue,
      disabled,
    } = this.props;
    const selectedIndex = findIndex(
      options,
      (option) => option.value === value
    );
    const selectedText = options[selectedIndex]
      ? options[selectedIndex].text
      : "";

    return (
      <div
        className={`select${focused ? " select--focused" : ""}`}
        aria-activedescendant={
          selectedIndex > -1
            ? `${this.props.id || "select_option"}_${this.id}_${selectedIndex}`
            : ""
        }
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
        disabled={disabled}
      >
        <select
          className="select__select"
          data-val="true"
          title="Wybierz sortowanie"
          required={required}
          tabIndex="0"
          disabled={disabled}
          aria-required={ariaRequired}
        >
          {map(options, (option, optionIndex) => (
            <option
              key={optionIndex}
              selected={
                isObjectValue
                  ? option.value === value.value
                  : option.value === value
              }
              value={isObjectValue ? option.value : option.value}
            >
              {option.text}
            </option>
          ))}
        </select>
        <div
          className={`select__selected ${disabled && "select__disabled"}`}
          tabIndex="0"
          ref={(ref) => {
            this.select = ref;
          }}
          onFocus={this.handleFocus}
          onBlur={this.handleBlur}
          role="listbox"
          aria-haspopup="true"
          title="Wybierz sortowanie"
        >
          <span style={{ width: "100%", overflow: "hidden" }}>
            {selectedText}
          </span>
        </div>
        {!disabled ? (
          <i className="select__icon fas fa-chevron-down" aria-hidden="true" />
        ) : null}
        <ul className="select__list" aria-expanded={focused}>
          {map(options, (option, optionIndex) => (
            <li
              key={optionIndex}
              className={`select__option${
                option.value === value ? " select__option--key-selected" : ""
              }`}
              role="option"
              onClick={this.handleSelect.bind(this, option)}
              aria-selected={option.value === value}
              id={`${this.props.id || "select_option"}_${
                this.id
              }_${optionIndex}`}
            >
              {option.text}
            </li>
          ))}
        </ul>
      </div>
    );
  }
}

// function Option(option, select, selectSelected, onSelectFunction, blurSelect) {
//     var text = option.innerText;
//     var selectOption = document.createElement('li');

//     selectOption.innerText = text;
//     selectOption.className = 'select__option';
//     selectOption.setAttribute('role', 'option');
//     selectOption.addEventListener('click', function () {
//         select.value = option.value;
//         option.selected = true;
//         select.querySelector('.select__option--key-selected').classList.remove('select__option--key-selected');
//         selectOption.classList.add('select__option--key-selected');
//         select.querySelector('.select__selected').innerText = option.innerText;
//         onSelectFunction(selectOption);
//         blurSelect();
//     });

//     return selectOption;
// }

// function Select(select, index) {
//     var options = select.querySelectorAll('select option');
//     var selectSelect = select.querySelector('select');
//     var selectList = select.querySelector('.select__list');
//     var selectSelected = select.querySelector('.select__selected');
//     var clicked = false;
//     var selectedOption = '';
//     var reallySelected = '';
//     var over = false;
//     var elementHeight = 41;
//     var amoutnOfOptions = options.length;
//     var toBlur = false;
//     var focusedNow = false;
//     var focusedMomentAgo = false;

//     select.addEventListener('mouseenter', function () {
//         over = true;
//     });

//     select.addEventListener('mouseleave', function () {
//         over = false;
//     });

//     selectSelected.addEventListener('focus', focusSelect.bind(this));

//     function focusSelect() {
//         if (!focusedNow) {
//             focusedMomentAgo = true;
//         }
//         focusedNow = true;
//         select.classList.add('select--focused');
//         selectedOption = reallySelected;
//         selectList.setAttribute('aria-expanded', true);
//     }

//     function blurSelect () {
//         if (over && !clicked && !toBlur) {
//             focusSelect();
//         } else {
//             toBlur = false;
//             select.classList.remove('select--focused');
//             select.querySelector('.select__option--key-selected').classList.remove('select__option--key-selected');
//             reallySelected.classList.add('select__option--key-selected');
//             focusedNow = false;
//             select.setAttribute('aria-activedescendant', reallySelected.id);
//             selectList.setAttribute('aria-expanded', false);

//             if (clicked && selectSelect.onchange) {
//                 selectSelect.onchange();
//             }

//             $(selectSelect).change()

//             clicked = false;
//         }
//     }

//     selectSelected.addEventListener('blur', blurSelect.bind(this));

//     selectSelected.addEventListener('click', function () {
//         if (!focusedMomentAgo) {
//             toBlur = true;
//         } else {
//             focusedMomentAgo = false;
//         }
//         blurSelect();
//     });

//     selectSelected.addEventListener('keydown', function (e) {
//         e.preventDefault();
//         e.stopPropagation();
//         if (e.keyCode === 13) {
//             selectedOption.click();
//         } else if (e.keyCode === 38) {
//             if (selectedOption.previousElementSibling) {
//                 selectedOption.classList.remove('select__option--key-selected');
//                 selectedOption = selectedOption.previousElementSibling;
//                 selectedOption.classList.add('select__option--key-selected');
//                 selectSelected.setAttribute('aria-activedescendant', selectedOption.id);

//                 var position = parseInt(selectedOption.dataset.position);

//                 selectList.scrollTo(0, (elementHeight * (position - 2)) - 1);
//             }
//         } else if (e.keyCode === 40) {
//             if (selectedOption.nextElementSibling) {
//                 selectedOption.classList.remove('select__option--key-selected');
//                 selectedOption = selectedOption.nextElementSibling;
//                 selectedOption.classList.add('select__option--key-selected');
//                 selectSelected.setAttribute('aria-activedescendant', selectedOption.id);

//                 var position = parseInt(selectedOption.dataset.position);

//                 selectList.scrollTo(0, (elementHeight * (position - 2)) - 1);
//             }
//         }
//     });

//     for (var j = 0; j < options.length; j++) {
//         var option = options[j];
//         var selectOption = new Option(option, select, selectSelected, function (sdO) {
//             reallySelected.setAttribute('aria-selected', false);
//             selectedOption = sdO;
//             reallySelected = sdO;
//             clicked = true;
//             selectedOption.setAttribute('aria-selected', true);
//         }, blurSelect.bind(this));

//         var id = 'select_option_' + index + '_' + j;

//         selectOption.setAttribute('id', id);

//         selectOption.dataset.position = j;

//         if (j === 0 || option.selected) {
//             if (selectedOption) {
//                 selectOption.classList.remove('select__option--key-selected');
//                 selectOption.setAttribute('aria-selected', false);
//             }

//             if (reallySelected) {
//                 reallySelected.classList.remove('select__option--key-selected');
//                 reallySelected.setAttribute('aria-selected', false);
//             }

//             selectSelected.innerText = option.innerText;
//             selectOption.classList.add('select__option--key-selected');
//             selectOption.setAttribute('aria-selected', true);
//             selectedOption = selectOption;
//             reallySelected = selectOption;
//             select.setAttribute('aria-activedescendant', id);
//         }

//         selectList.appendChild(selectOption);
//     }
// }

// for (var i = 0; i < selects.length; i++) {
//     var select = new Select(selects[i], i);
// }
